module.exports = __webpack_public_path__ + "static/media/natural-strawberry-colada.2a3a1fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/natural-strawberry-colada.png
// module id = 173
// module chunks = 0